import I18n from '~/src/common/services/I18n';
import BasicItem from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/components/BasicItem';
import ArticleItemCell from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/components/EssentialsPanel/ArticleItemCell';
import { RecipeEssentialProduct } from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/types';

import * as GS from '../../layout';

import * as S from './layout';

interface Props {
  essentialProducts: RecipeEssentialProduct[];
  recipeId: string;
}

const EssentialsPanel = ({ essentialProducts, recipeId }: Props) => {
  return (
    <div>
      <GS.SectionName>{I18n.t('recipe-screen.essentials-title')}</GS.SectionName>
      <S.EssentialsItemsContainer>
        {essentialProducts.map(({ article, name }) =>
          article ? (
            <ArticleItemCell key={article.id} article={article} recipeId={recipeId} />
          ) : (
            <BasicItem key={name} name={name} />
          ),
        )}
      </S.EssentialsItemsContainer>
    </div>
  );
};

export default EssentialsPanel;
